export const ReportsInformationTableColumns = [
  { key: 'sn', label: '' },
  { key: 'action', label: 'Action' },
  { key: 'jobOrder', label: 'Job Order #' },
  { key: 'vesselName', label: 'Vessel' },
  { key: 'serialNumber', label: 'Serial Number' },
  { key: 'siteName', label: 'Job Site' },
  { key: 'model', label: 'Model Number' },
  { key: 'analyst', label: 'Analyst' },
  { key: 'inspectionDate', label: 'Inspection Date' },
  { key: 'isMultiOffset', label: 'Is Multi Offset?' },
];
export const VesselReportsTableColumns = [
  { key: 'sn', label: '' },
  { key: 'action', label: 'Action' },
  { key: 'jobOrder', label: 'Job Order #' },
  { key: 'vesselName', label: 'Vessel' },
  { key: 'section', label: 'Section' },
  { key: 'tubeCount_nosort', label: 'Tube Count' },
];
